module.exports = "label.g_acquereur {\n  cursor: pointer; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/app-form-g/app-form-g.component.scss
// module id = ./src/app/components/app-form-g/app-form-g.component.scss
// module chunks = main